import { BLANK_BACKGROUND, COLOUR_MAPPINGS, makeGradientBackground } from '../constants/background';
import { BLANK } from '../constants/useOptions';
const getColourPattern = useOption => COLOUR_MAPPINGS[useOption];
export const getBackground = ({
  use
}) => use === BLANK ? BLANK_BACKGROUND : makeGradientBackground(getColourPattern(use));